import { defineComponent as _defineComponent } from 'vue'
import { ref, toRefs } from 'vue'
import type { Ref } from 'vue'
import { useSubmit } from '../forms/FormMixin'
import useGlobal from '../../composables/useGlobal'
import { orderRetrieveResource, orderPaymentResource } from '@/services/order.service'
import executeWithRefresh from '@/composables/useRefresher'
import useDeviceInfo from '@/composables/useDevice'
import { storage } from '@/utils/session'
import {
  HQ_VPN_CURRENT_PAYMENT_ID_NAME,
  HQ_VPN_CURRENT_PAYMENT_URL_NAME,
} from '@/const'
import { STATE } from '@/utils/base64'


export default /*#__PURE__*/_defineComponent({
  __name: 'Cancel',
  props: ['subscriptionlink'],
  setup(__props, { expose }) {
  expose();

const props = __props

const { $t } = useGlobal()
const paymentStatus = ref('NEW')

const { subscriptionlink } = toRefs(props)

const { indexPage } = window

const load: Ref = ref(false)
const statuses = ref({
  '020-new': 'NEW',
  '060-failed': 'FAILED',
  '080-success': 'SUCCESS',
})

const parseGetParams = () => {
  if (window.location.search) {
    const [search] = window.location.search.substring(1).split('&')
    const result = STATE.parse(search)
    return result
  }
}

const getPaymentUrl = () => storage.getItem(HQ_VPN_CURRENT_PAYMENT_URL_NAME)
const getOrderUrl = () => {
  const data = {
    ...parseGetParams()
  }
  return `${subscriptionlink.value}?${STATE.stringify(data)}`
}

  
const __returned__ = { $t, paymentStatus, props, subscriptionlink, indexPage, load, statuses, parseGetParams, getPaymentUrl, getOrderUrl, ref, toRefs, useSubmit, useGlobal, orderRetrieveResource, orderPaymentResource, executeWithRefresh, useDeviceInfo, storage, HQ_VPN_CURRENT_PAYMENT_ID_NAME, HQ_VPN_CURRENT_PAYMENT_URL_NAME, STATE }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})